import { render } from "./ExamScore.vue?vue&type=template&id=23f71a62&scoped=true"
import script from "./ExamScore.vue?vue&type=script&lang=js"
export * from "./ExamScore.vue?vue&type=script&lang=js"

import "./ExamScore.vue?vue&type=style&index=0&id=23f71a62&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f71a62"]])

export default __exports__